export enum Feature {
  BUG_REPORT = 'BUG_REPORT',
  SELENIUM_EXPORT = 'SELENIUM_EXPORT',
  SLACK_NOTIFICATIONS = 'SLACK_NOTIFICATIONS',
  AUTO_HEALING = 'AUTO_HEALING',
  SAML = 'SAML',
  MANUAL_TESTING = 'MANUAL_TESTING',
  MS_Teams = 'MS_Teams',
  MS_Teams_Connector = 'MS_Teams_Connector',
  VISUAL_ANALYSIS = 'VISUAL_ANALYSIS',
  API = 'API',
  MOBILE_AUTOMATION = 'MOBILE_AUTOMATION',
  CUSTOM_FIELDS = 'CUSTOM_FIELDS',
  SCHEDULE_EXECUTIONS = 'SCHEDULE_EXECUTIONS',
  ANALYTICS = 'ANALYTICS',
  RESULTS_FILTERING = 'RESULTS_FILTERING',
  MULTI_APPLICATION = 'MULTI_APPLICATION',
  MULTI_VERSION = 'MULTI_VERSION',
  ACCOUNT_BACKUP = 'ACCOUNT_BACKUP',
  AFFECTED_LIST = 'AFFECTED_LIST',
  INTEGRATIONS = 'INTEGRATIONS',
  SSO = 'SSO',
  SMTP_CONFIGURATION = 'SMTP_CONFIGURATION',
  PREFERENCES = 'PREFERENCES',
  DATA_CLEAN_UP = 'DATA_CLEAN_UP',
  REST_AUTOMATION = 'REST_AUTOMATION',
  UNLIMITED_AUTOMATION_DEVICES = 'UNLIMITED_AUTOMATION_DEVICES',
  UNLIMITED_AUTOMATION_BROWSERS = 'UNLIMITED_AUTOMATION_BROWSERS',
  TEST_CASE_REVIEW_MANAGEMENT = 'TEST_CASE_REVIEW_MANAGEMENT',
  SELF_REVIEW_MANAGEMENT = 'SELF_REVIEW_MANAGEMENT',
  TESTSIGMA_EXPERT_SERVICE = 'TESTSIGMA_EXPERT_SERVICE',
  MOBILE_INSPECTION_CLOUD = 'MOBILE_INSPECTION_CLOUD',
  MOBILE_INSPECTION_LOCAL_ANDROID = 'MOBILE_INSPECTION_LOCAL_ANDROID',
  MOBILE_INSPECTION_LOCAL_IOS = 'MOBILE_INSPECTION_LOCAL_IOS',
  MOBILE_OTP = 'MOBILE_OTP',
  TESTSIGMA_SDK = 'TESTSIGMA_SDK',
  RETRY_DEVICE_ALLOCATION = 'RETRY_DEVICE_ALLOCATION',
  MAIL_BOX = 'MAIL_BOX',
  HYBRID_EXECUTIONS = 'HYBRID_EXECUTIONS',
  UI_IDENTIFIER_REVIEW_MANAGEMENT = 'UI_IDENTIFIER_REVIEW_MANAGEMENT',
  STEP_GROUP_SUPPORT_ON_IF = 'STEP_GROUP_SUPPORT_ON_IF',
  FRESH_RELEASE_INTEGRATION = 'FRESH_RELEASE_INTEGRATION',
  YOU_TRACK_INTEGRATION = 'YOU_TRACK_INTEGRATION',
  MANTIS_INTEGRATION = 'MANTIS_INTEGRATION',
  AZURE_INTEGRATION = 'AZURE_INTEGRATION',
  BACKLOG_INTEGRATION = 'BACKLOG_INTEGRATION',
  BUGZILLA_INTEGRATION = 'BUGZILLA_INTEGRATION',
  TRELLO_INTEGRATION = 'TRELLO_INTEGRATION',
  BROWSERSTACK_INTEGRATION = 'BROWSERSTACK_INTEGRATION',
  SAUCE_LABS_INTEGRATION = 'SAUCE_LABS_INTEGRATION',
  KOBITON_INTEGRATION = 'KOBITON_INTEGRATION',
  LAMBDA_TEST_INTEGRATION = 'LAMBDA_TEST_INTEGRATION',
  GOOGLE_CHAT_INTEGRATION = 'GOOGLE_CHAT_INTEGRATION',
  CODESHIP_CI_INTEGRATION = 'CODESHIP_CI_INTEGRATION',
  PRIVATE_GRID = 'PRIVATE_GRID',
  LINEAR_INTEGRATION = 'LINEAR_INTEGRATION',
  CLICK_UP_INTEGRATION = 'CLICK_UP_INTEGRATION',
  CIRCLE_CI_INTEGRATION = 'CIRCLE_CI_INTEGRATION',
  BAMBOO_INTEGRATION = 'BAMBOO_INTEGRATION',
  AWS_INTEGRATION = 'AWS_INTEGRATION',
  TRAVIS_CI_INTEGRATION = 'TRAVIS_CI_INTEGRATION',
  RUN_IN_DEBUG_ON_LOCAL_DEVICES = 'RUN_IN_DEBUG_ON_LOCAL_DEVICES',
  RUN_IN_WEB_DEBUG_ON_LOCAL_DEVICES = 'RUN_IN_WEB_DEBUG_ON_LOCAL_DEVICES',
  RUN_TEST_CASES_IN_PARALLEL_ON_WEB = 'RUN_TEST_CASES_IN_PARALLEL_ON_WEB',
  WINDOWS_APP_AUTOMATION = 'WINDOWS_APP_AUTOMATION',
  MAC_APP_AUTOMATION = 'MAC_APP_AUTOMATION',
  LEAP_TEST_PLAN_UI = 'LEAP_TEST_PLAN_UI',
  USER_LEVEL_PARALLEL_LICENSE = 'USER_LEVEL_PARALLEL_LICENSE',
  PARTIAL_TEST_PLAN_RUN = 'PARTIAL_TEST_PLAN_RUN',
  MOBILE_PARALLEL_EXECUTIONS = 'MOBILE_PARALLEL_EXECUTIONS',
  ON_BOARDING_POPUP = 'ON_BOARDING_POPUP',
  MOBILE_INSPECTOR_V2 = 'MOBILE_INSPECTOR_V2',
  ANDROID_EMULATOR = 'ANDROID_EMULATOR',
  IOS_SIMULATOR = 'IOS_SIMULATOR',
  REACT_MIGRATION_V1 = 'REACT_MIGRATION_V1',
  REVAMP_UI_V2 = 'REVAMP_UI_V2',
  AFTER_TEST = 'AFTER_TEST',
  AFTER_TEST_SUITE = 'AFTER_TEST_SUITE',
  OVERRIDE_RESULT = 'OVERRIDE_RESULT',
  PDF_REPORT_EXPORT = 'PDF_REPORT_EXPORT',
  AGENT_REVAMP = 'AGENT_REVAMP',
  SETTINGS_REVAMP = 'SETTINGS_REVAMP',
  CONTROL_EXECUTION_STOP_ACTION = 'CONTROL_EXECUTION_STOP_ACTION',
  CONTROL_USERS_PASSWORD = 'CONTROL_USERS_PASSWORD',
  TEST_PLAN_HOOK = 'TEST_PLAN_HOOK',
  DATABASE_TESTING = 'DATABASE_TESTING',
  SALESFORCE_AUTOMATION = 'SALESFORCE_AUTOMATION',
  TS_WIN_TEST_AUTOMATION = 'TS_WIN_TEST_AUTOMATION',
  DASHBOARD_REVAMP = 'DASHBOARD_REVAMP',
  PROJECT_SETTINGS_REVAMP = 'PROJECT_SETTINGS_REVAMP',
  SCREENSHOT_MODE_FOR_HYBRID_LOCAL = 'SCREENSHOT_MODE_FOR_HYBRID_LOCAL',
  LOCAL_PARALLEL_RUN = 'LOCAL_PARALLEL_RUN',
  CUSTOM_FUNCTIONS_LEAP_UI = 'CUSTOM_FUNCTIONS_LEAP_UI',
  RESET_SESSION_AT_SUITE_LEVEL = 'RESET_SESSION_AT_SUITE_LEVEL',
  CREATE_SESSION_AT_ITERATION_LEVEL = 'CREATE_SESSION_AT_ITERATION_LEVEL',
  TEST_CASE_LEVEL_MULTI_DRIVER_SESSION = 'TEST_CASE_LEVEL_MULTI_DRIVER_SESSION',
  GEN_AI = 'GEN_AI',
  GEN_AI_BYOK = 'GEN_AI_BYOK',
  HIGHLIGHT_ELEMENT = 'HIGHLIGHT_ELEMENT',
  INSTALL_APP_IN_RECORDER = 'INSTALL_APP_IN_RECORDER',
  ACCESSIBILITY_TESTING = 'ACCESSIBILITY_TESTING',
  TEST_CASE_RESULT_REPORTS = 'TEST_CASE_RESULT_REPORTS',
  PREVENT_AUTO_REFRESH_IN_WINDOWS_RECORDER = 'PREVENT_AUTO_REFRESH_IN_WINDOWS_RECORDER',
  MOBILE_RECORDER_FREEFLOW = 'MOBILE_RECORDER_FREEFLOW',
  TESTSIGMA_CONNECT = 'TESTSIGMA_CONNECT',
  MOBILE_RECORDER_LOCAL_SOURCE_PARSING = 'MOBILE_RECORDER_LOCAL_SOURCE_PARSING',
  ACCESSIBILITY_TESTING_ANDROID = 'ACCESSIBILITY_TESTING_ANDROID',
  ACCESSIBILITY_TESTING_IOS = 'ACCESSIBILITY_TESTING_IOS',
  DESIGN_ASSET_VISUAL_ANALYSIS = 'DESIGN_ASSET_VISUAL_ANALYSIS',
  AGENTIC_AI = 'AGENTIC_AI',
  IMPORT_ARTEFACTS = 'IMPORT_ARTEFACTS',
  ACCESSIBILITY_TESTING_SALESFORCE = 'ACCESSIBILITY_TESTING_SALESFORCE'
}
